import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const rolePermissionsBaseEndpoint = ENDPOINTS.ROLE_PERMISSION;

// Daily Orders API
export const rolePermissionApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["rolePermissions"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getRolePermission: builder.query({
        query: ({ page = 1, per_page = 10, search = "" } = {}) => ({
          url: rolePermissionsBaseEndpoint,
          params: {
            page,
            per_page,
            ...(search && { search }), // Only include search if it has a value
          },
        }),
        transformResponse: (response) => response,
        providesTags: () => [{ type: "rolePermissions" }],
      }),
      addRolePermission: builder.mutation({
        query: (requestData) => ({
          url: `${rolePermissionsBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "rolePermissions" }],
      }),
      updateRolePermission: builder.mutation({
        query: (requestData) => ({
          url: `${rolePermissionsBaseEndpoint}/update-permissions`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "rolePermissions" }],
      }),
      deleteRolePermission: builder.mutation({
        query: (id) => ({
          url: `${rolePermissionsBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "rolePermissions" }],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetRolePermissionQuery,
  useAddRolePermissionMutation,
  useUpdateRolePermissionMutation,
  useDeleteRolePermissionMutation,
} = rolePermissionApi;
